/** @jsxImportSource @emotion/react */
import { Typography, useTheme } from '@quickbit/qb-design-system';
import { CaseNote } from 'api/useCasesApi';

const MAX_NOTE_LENGTH = 40;

export const CaseNotesCell = ({ notes }: { notes: CaseNote[] }) => {
  const { spacing, palette } = useTheme();

  if (notes.length === 0) {
    return (
      <Typography variant="bodySmall" color={palette.grey.x400}>
        No notes
      </Typography>
    );
  }

  const latestNote = notes[notes.length - 1];

  return (
    <div css={{ position: 'relative', '&:hover > div': { display: 'block' } }}>
      <Typography variant="bodySmall">
        {latestNote.content.length > MAX_NOTE_LENGTH
          ? `${latestNote.content.slice(0, MAX_NOTE_LENGTH)}...`
          : latestNote.content}
      </Typography>
      {notes.length > 0 && (
        <div
          css={{
            display: 'none',
            position: 'absolute',
            zIndex: 10,
            bottom: '100%',
            right: '70%',
            maxWidth: 400,
            maxHeight: 300,
            overflowY: 'auto',
            backgroundColor: palette.grey.x900,
            borderRadius: 8,
            padding: spacing.xxxs,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          }}
        >
          {notes.map((note, i) => (
            <div
              key={i}
              css={{
                padding: spacing.xxxs,
                borderBottom:
                  i < notes.length - 1
                    ? `1px solid ${palette.grey.x600}`
                    : 'none',
                textWrap: 'nowrap',
              }}
            >
              <Typography variant="bodySmall" color="#FFFFFF">
                {note.content}
              </Typography>
              <div css={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="bodySmallest" color={'#FFFFFF'}>
                  {note.createdBy}
                </Typography>
                <Typography variant="bodySmallest" color={'#FFFFFF'}>
                  {new Date(note.createdAt).toLocaleString()}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
